import React from 'react';
import challengePropType from './propTypes';
import Picture from '../Picture';
import { PICTURE_VARIANTS as SIZES } from '../constants';
import ToggleButton from '../ToggleButton';
import './styles.scss';
import { noop } from '../propTypes';
import { CHALLENGE_TYPES } from '../constants';
import ProgressBar from '../ProgressBar';
import TitlePill from '../TitlePill';

function ChallengeRow({
    id,
    thumbnail,
    name,
    description,
    badge,
    pickups,
    target,
    startDate,
    endDate,
    onToggle,
    toggleState,
    progress,
    isMember,
}) {
    return (
        <div>
            <div className="content-box challengesContentCard">
                <div className="listGroup">
                    <div className="challengesCardAvatar grid">
                        <Picture
                            variant={SIZES.VARIANT_LARGE}
                            source={thumbnail}
                        />
                    </div>
                    <div className="challengesCardContent grid">
                        <div className="card-header">
                            <h2>
                                {name}
                                <TitlePill
                                    badgeTitle={badge}
                                    badgeStyle={
                                        badge == CHALLENGE_TYPES.GLOBAL
                                            ? 'primary'
                                            : 'secondary'
                                    }
                                />
                            </h2>
                            <span
                                style={{
                                    textTransform: 'uppercase',
                                    fontFamily: 'Proxima Nova Rg',
                                    letterSpacing: 0.5,
                                    fontSize: 12,
                                }}
                            >
                                Challenge ID: {id}
                            </span>
                            <p>{description}</p>
                            <small>{`${startDate} - ${endDate}`}</small>
                        </div>
                    </div>
                    <div
                        className="challengesCardToggle grid"
                        style={isMember ? { justifyContent: 'flex-end' } : {}}
                    >
                        {!isMember && (
                            <ToggleButton
                                id={id}
                                onToggle={onToggle}
                                toggleState={toggleState}
                                classNames="toggle-switch"
                            />
                        )}
                        <div className="avg">
                            <p>
                                <span>{`Pickups ${pickups}`}</span>
                                {`/${target}`}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <ProgressBar progress={progress} isRounded />
        </div>
    );
}

ChallengeRow.propTypes = challengePropType;

ChallengeRow.defaultProps = {
    id: null,
    thumbnail: null,
    name: null,
    badge: null,
    description: null,
    pickups: 0,
    target: 0,
    progress: 0,
    startDate: '',
    endDate: '',
    isMember: false,
    onToggle: noop,
    toggleState: false,
};

export default ChallengeRow;
